export default "__VITE_ASSET__Cju8wKBX__"